"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Variables_1 = require("../../Variables");
var ButtonStyles = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: transparent;\n  border: none;\n  color: ", ";\n  cursor: ", ";\n  display: block;\n  line-height: 0;\n  margin: 0;\n  min-width: 40px;\n  min-height: 40px;\n  outline: none;\n  padding: 0;\n  position: relative;\n  ", "\n"], ["\n  background-color: transparent;\n  border: none;\n  color: ", ";\n  cursor: ", ";\n  display: block;\n  line-height: 0;\n  margin: 0;\n  min-width: 40px;\n  min-height: 40px;\n  outline: none;\n  padding: 0;\n  position: relative;\n  ", "\n"])), Variables_1.color.BRAND_GREY, function (props) { return (props.disabled ? 'not-allowed' : 'pointer'); }, function (props) {
    return props.disabled
        ? ''
        : "\n  &:hover {\n    outline: none;\n    color: ".concat(Variables_1.color.BRAND_WHITE, ";\n  }\n  \n  &:focus {\n    outline: none;\n    color: ").concat(Variables_1.color.BRAND_WHITE, ";\n  }\n  ");
});
var NotificationStyles = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  display: inline-block;\n  font-size: 12px;\n  line-height: 1em;\n  min-width: 18px;\n  padding: 3px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  &:after {\n    content: '';\n    background-color: ", ";\n    border-radius: 100%;\n    bottom: 0;\n    display: block;\n    margin: auto;\n    padding: 0 0 100% 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: -1;\n  }\n"], ["\n  color: ", ";\n  display: inline-block;\n  font-size: 12px;\n  line-height: 1em;\n  min-width: 18px;\n  padding: 3px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  &:after {\n    content: '';\n    background-color: ", ";\n    border-radius: 100%;\n    bottom: 0;\n    display: block;\n    margin: auto;\n    padding: 0 0 100% 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: -1;\n  }\n"])), Variables_1.color.BRAND_WHITE, Variables_1.color.FUNCTIONAL_RED);
var HeaderButton = React.forwardRef(function (props, ref) {
    var children = props.children, onClick = props.onClick, notification = props.notification, rest = __rest(props, ["children", "onClick", "notification"]);
    return (React.createElement(ButtonStyles, __assign({ ref: ref }, rest, (!props.disabled && {
        onClick: onClick,
    })),
        notification && React.createElement(NotificationStyles, null, notification),
        children));
});
exports.default = HeaderButton;
var templateObject_1, templateObject_2;
